/**
 * Demo giriş ekranının metinleri (ADR 0026): rol kartları, kullanım kataloğu, sunum akışları.
 * `features` ve `steps` SATIR SATIR yazılır (her satır bir madde); menü yolları arayüzdeki adlarla aynıdır.
 */
export const trDemo = {
  badge: "Canlı demo",
  documentTitle: "Demo — rol seçin",
  nav: {
    label: "Demo bölümleri",
    accounts: "Rol seçin",
    scenarios: "Sunum akışları",
    catalog: "Kullanım kataloğu",
    classicLogin: "E-posta ile giriş",
  },
  hero: {
    title: "İstasyonunuzun tamamı tek ekranda",
    subtitle:
      "Akaryakıt istasyonu işletmeciliğinin bütün süreçleri tek platformda. Her kullanıcı yalnızca kendi işini görür; parola gerekmez.",
    primary: "İşletme sahibi olarak başla",
    catalog: "Kullanım kataloğu",
    steps: {
      role: {
        title: "Rolünüzü seçin",
        text: "Kart, o kişinin yetkisi ve istasyonuyla tek tıkla giriş yapar.",
      },
      task: {
        title: "İşinizi seçin",
        text: "Ana sayfada rolünüzün işleri hazırdır: “Vardiya aç”, “Endeks okuması gir”, “Mal kabul”…",
      },
      form: {
        title: "Formu doldurun",
        text: "Form doğrudan açılır; kaydettiğiniz veri raporlara ve bekleyen işlere anında yansır.",
      },
    },
  },
  accounts: {
    title: "Bir rol seçin",
    description:
      "Her kart gerçek bir kullanıcıdır: tıkladığınızda o kişinin yetkisiyle girer ve yalnızca onun işlerini görürsünüz. Başka role geçmek için sağ üstteki kullanıcı menüsünden “Rol değiştir”i seçin.",
    signIn: "Giriş yap",
    signInAs: "{{name}} ({{role}}) olarak giriş yap",
    signingIn: "Giriş yapılıyor…",
    featured: "Sunum için önerilen",
    failed: "Giriş yapılamadı",
    others: "Diğer hesaplar ({{count}})",
    othersHint: "Ödemesi geciken işletme ve yazılımı sunan platform ekibi",
    organizations: {
      chain: {
        title: "Zincir işletme",
        name: "Zincir Demo",
        description:
          "İstanbul, Bursa, İzmir ve Aydın'da 5 istasyon; iki şirket, iki bölge. Akaryakıt, LPG, market, yıkama, şarj, kafe ve kiralık alan birimleri açık.",
        plan: "Kurumsal plan",
      },
      single: {
        title: "Tek istasyonlu işletme",
        name: "Tek İstasyon Demo",
        description:
          "İzmir Bornova'da tek istasyon, şahıs şirketi. Bölge ve istasyon seçicileri gizlenir; arayüz sadeleşir, veri modeli aynıdır.",
        plan: "Profesyonel plan",
      },
      overdue: {
        title: "Ödemesi geciken işletme",
        name: "Gecikme Petrol Ltd.",
        description:
          "Abonelik ödemesi gecikmiş bir işletme: hesap salt okunur kipe geçer, veriler görünür ama yeni kayıt girilemez.",
        plan: "Salt okunur",
      },
      platform: {
        title: "Platform ekibi",
        name: "Yazılımı sunan taraf",
        description:
          "İşletmeleri, planları, abonelik faturalarını ve destek erişimini yöneten ekip. İşletme verisine yalnızca işletmenin onayıyla, salt okunur girilir.",
        plan: "Platform paneli",
      },
    },
  },
  personas: {
    chainOwner: {
      role: "İşletme sahibi",
      scope: "Tüm işletme",
      summary: "Bütün istasyonların durumu, onaylar, fiyat değişikliği ve raporlar. Sunuma buradan başlayın.",
    },
    chainAdmin: {
      role: "Yönetici",
      scope: "Tüm işletme",
      summary: "Sahiple aynı görünüm; ayrıca kullanıcı davet eder, rolleri ve istasyon ayarlarını yönetir.",
    },
    regionManager: {
      role: "Bölge müdürü",
      scope: "Marmara bölgesi",
      summary: "Bölgesindeki istasyonları karşılaştırır; alarmları, onayları ve bakım işlerini izler.",
    },
    stationManager: {
      role: "İstasyon müdürü",
      scope: "Kadıköy istasyonu",
      summary: "Vardiya açar, günü kapatır; tank, dolum, market ve gider kayıtlarını girer.",
    },
    accountant: {
      role: "Muhasebe",
      scope: "Ege şirketi",
      summary: "Fatura keser, gelen e-faturayı deftere alır; cari, kasa / banka hareketi ve fiş girer.",
    },
    advisor: {
      role: "Mali müşavir",
      scope: "İki işletme",
      summary:
        "Birden çok işletmenin defterini izler; beyan takvimi ve muhasebe raporları. Üstteki seçiciden işletme değiştirir.",
    },
    auditor: {
      role: "Denetçi",
      scope: "Tüm işletme, salt okunur",
      summary: "Her şeyi görür, hiçbir şeyi değiştiremez; denetim izi ve raporlar.",
    },
    chainCashier: {
      role: "Kasiyer",
      scope: "Bayraklı istasyonu",
      summary: "Endeks ve tank okuması, mal kabul ve sayım girer; yıkama ve şarj başlatır.",
    },
    fleetPortal: {
      role: "Filo müşterisi",
      scope: "Müşteri portalı",
      summary: "İşletmenin filo müşterisi: araçları, tüketimi, faturaları ve talepleri.",
    },
    singleOwner: {
      role: "İşletme sahibi",
      scope: "Tek istasyon",
      summary: "Sadeleşmiş arayüz: bölge ve istasyon seçimi yok, her şey tek istasyon için.",
    },
    singleCashier: {
      role: "Kasiyer",
      scope: "Bornova istasyonu",
      summary: "Kendi vardiyası; sayaç ve tank okuması, mal kabul ve sayım girer.",
    },
    pumpAttendant: {
      role: "Pompacı",
      scope: "Bornova istasyonu",
      summary: "En dar yetki: kendi vardiyasını kapatır, sayaç ve tank okuması girer.",
    },
    overdueOwner: {
      role: "İşletme sahibi",
      scope: "Salt okunur hesap",
      summary: "Ödeme gecikince hesabın nasıl kısıtlandığını ve uyarıları gösterir.",
    },
    platformAdmin: {
      role: "Süper yönetici",
      scope: "Platform",
      summary: "İşletmeler, planlar, faturalama, duyurular, ajan yayınları ve sistem sağlığı.",
    },
    platformSupport: {
      role: "Destek",
      scope: "Platform",
      summary: "Destek istekleri; işletme onay verince salt okunur destek oturumu.",
    },
    platformFinance: {
      role: "Finans",
      scope: "Platform",
      summary: "Abonelik faturaları, tahsilat ve gecikme süreci.",
    },
    platformReadOnly: {
      role: "İzleme",
      scope: "Platform, salt okunur",
      summary: "Platform panelini izler; değişiklik yapamaz.",
    },
  },
  scenarios: {
    title: "Önerilen sunum akışları",
    description:
      "Birkaç dakikalık hazır turlar. Her biri doğru hesapla giriş yapar ve başlangıç sayfasını açar; adımları sırayla izleyin.",
    minutes: "≈ {{count}} dk",
    start: "Bu akışı başlat",
    startAs: "{{name}} olarak başlat",
    items: {
      overview: {
        title: "Genel bakış turu",
        summary: "İşletmenin o anki durumunu tek ekrandan okumak.",
        steps:
          "Ana sayfadaki “Bekleyen işler” listesine bakın: alarmlar, onaylar, kritik tanklar; her satırın tek tıklık eylemi vardır.\nÜstteki istasyon seçiciden bir istasyon seçin; bütün ekranlar o istasyona süzülür.\nRaporlar › İstasyon karşılaştırma ile istasyonları ciro, hacim ve kâra göre yan yana görün.\nSağ üstteki zil simgesinden bildirimleri, Alarmlar menüsünden alarm ayrıntısını açın.",
      },
      wetStock: {
        title: "Tanktan mutabakata",
        summary: "Yakıtın tanka girişinden satışa, farkın nedenine kadar izlemek.",
        steps:
          "Akaryakıt › Tanklar: doluluk, su seviyesi, sıcaklık ve tahmini bitiş; veriler dakikada bir tazelenir.\nAkaryakıt › Tanker dolumları: bir dolumu açın; irsaliye ile ölçülen miktar farkını ve itiraz tutanağını görün.\nAkaryakıt › Mutabakat: günlük ıslak stok mutabakatı; fark tolerans içinde mi, fire mi, kaçak şüphesi mi.\nAkaryakıt › Fire raporu ve Stok maliyeti ile dönemi kapatın.",
      },
      dayEnd: {
        title: "Vardiyadan gün sonuna",
        summary: "Pompacı hesabından kilitli güne: istasyon müdürünün her günkü işi.",
        steps:
          "Vardiya › Vardiya panosu: açık vardiyalar, personel ve beklenen tahsilat.\nVardiya › Vardiyalar: kapanmış bir vardiyayı açın; nakit, kart ve veresiye dökümü ile açık / fazla farkını görün.\nVardiya › Gün sonu: Z raporu karşılaştırması, akaryakıt mutabakatı ve günün kilitlenmesi.\nVardiya › Z raporları: yazar kasa toplamlarıyla sistem satışlarının karşılaştırması.",
      },
      invoiceToLedger: {
        title: "Gelen e-faturayı deftere almak",
        summary: "Tedarikçi faturası üç tıkla muhasebeleşir; sistem seçimlerinizi öğrenir.",
        steps:
          "Fatura ve e-belge › Gelen kutusu: deftere alınmayı bekleyen e-faturalar ve son yanıt tarihleri.\nBir belgeyi açın: tedarikçi eşleşmesi ve satır satır hesap / ürün önerisi hazır gelir.\n“Deftere al” ile alış faturası, cari borcu ve KDV kaydı tek işlemde oluşur.\nCari hesaplar › Cariler'den tedarikçinin ekstresinde açık kalemi görün.",
      },
      evCharging: {
        title: "Şarj oturumu",
        summary: "Şarj ünitesinin canlı durumu, uzaktan başlatma ve faturalama.",
        steps:
          "Şarj › Şarj panosu: konnektörlerin canlı durumu ve bugünün özeti.\nBoş bir konnektörde “Uzaktan başlat”ı deneyin; simülatör birkaç saniyede yanıt verir.\nŞarj › Şarj oturumları: enerji, süre, tarife ve ödeme durumu.\nŞarj › Şarj tarifeleri: saat dilimli fiyat ve bekleme ücreti tanımları.",
      },
      roles: {
        title: "Rol ve kapsam farkı",
        summary: "Aynı ekranın farklı kullanıcılara nasıl göründüğünü göstermek.",
        steps:
          "İstasyon müdürüyle girin: menüde yalnızca “İşlerim” vardır, veriler Kadıköy istasyonuyla sınırlıdır.\nKullanıcı menüsünden “Rol değiştir” ile bu sayfaya dönün, kasiyerle girin: menü on sayfaya iner, ana sayfada okuma ve mal kabul düğmeleri vardır.\nDenetçiyle girin: her şey görünür, kaydet düğmeleri yoktur.\nYönetici hesabında Ayarlar › Roller'den özel rol ve kapsam tanımlamayı gösterin.",
      },
    },
  },
  catalog: {
    title: "Kullanım kataloğu",
    description:
      "Platformun bütün modülleri ve her birini en iyi gösteren hesap. Kartın ayrıntısında neler yapıldığı ve demoda nasıl denendiği yazar.",
    search: "Modül ara",
    searchPlaceholder: "Örn. mutabakat, e-fatura, çek, şarj…",
    all: "Tümü",
    empty: "Aramanızla eşleşen modül bulunamadı.",
    count: "{{count}} modül",
    details: "Neler yapılır, nasıl denenir",
    features: "Neler yapılır",
    steps: "Demoda deneyin",
    menuPath: "Menüde",
    open: "Modülü aç",
    openAs: "{{name}} ({{role}}) olarak “{{module}}” modülünü aç",
    bestWith: "Önerilen rol",
    categories: {
      operations: "Saha operasyonu",
      finance: "Finans ve muhasebe",
      customers: "Müşteri ve filo",
      management: "Yönetim ve raporlama",
      platform: "Abonelik ve platform",
    },
  },
  modules: {
    fuel: {
      title: "Tank, satış ve endeks",
      menu: "Akaryakıt › Tanklar",
      summary:
        "Tank probundan ve pompa otomasyonundan gelen veri anlık izlenir: tank doluluğu, su ve sıcaklık ölçümü, tabanca satışları ve sayaç (endeks) okumaları.",
      features:
        "Tank doluluğu, net hacim (15 °C), su seviyesi ve sıcaklık; güvenli üst sınır ve minimum seviye uyarıları\nTüketim hızına göre tahmini bitiş tarihi ve sipariş önerisi\nTabanca, ürün ve ödeme türüne göre akaryakıt satışları\nEndeks okumaları ve sayaç ile satış arasındaki tutarlılık denetimi\nKalibrasyon (mm → litre) tabloları tank bazında tanımlanır",
      steps:
        "Tanklar ekranında istasyon seçin; seviye grafiğini ve son okuma saatini izleyin.\nAkaryakıt satışları'nda bugünün satışlarını ürün ve tabancaya göre süzün.\nEndeks ekranında sayaç okumalarıyla satış toplamını karşılaştırın.",
    },
    fuelSupply: {
      title: "Sipariş, dolum ve mutabakat",
      menu: "Akaryakıt › Mutabakat",
      summary:
        "Dağıtıcıya siparişten tanker boşaltmaya, günlük ıslak stok mutabakatından fire ve maliyet raporuna kadar tedarik zinciri.",
      features:
        "Sipariş önerisi: tank seviyesi, tüketim ve teslim süresine göre\nTanker dolumu: irsaliye ile ölçülen miktarın karşılaştırılması, tolerans dışı farkta itiraz tutanağı (PDF)\nGünlük ıslak stok mutabakatı: fark fire mi, ölçüm hatası mı, kaçak şüphesi mi sınıflandırılır\nFire raporu, fiyat farkı raporu ve ağırlıklı ortalama stok maliyeti\nDolum, alış faturası ve irsaliye birbirine bağlanır",
      steps:
        "Mutabakat ekranında bir günü açın; açılış, dolum, satış ve kapanış dengesini inceleyin.\nTanker dolumları'nda farkı olan bir dolumun tutanağını indirin.\nSipariş önerileri'nde sistemin önerdiği miktarı siparişe çevirin.",
    },
    shifts: {
      title: "Vardiya ve gün sonu",
      menu: "Vardiya › Vardiya panosu",
      summary:
        "Pompacı ve kasiyer hesapları, teslim tutanakları, kasa farkları ve günün kilitlenmesi. Gün sonu, satışları muhasebeye kendiliğinden aktarır.",
      features:
        "Vardiya şablonları, personel ataması ve canlı vardiya panosu\nPompacı / kasiyer hesabı: beklenen tahsilat, teslim edilen, açık ve fazla\nTeslim–tesellüm tutanağı (PDF) ve fark onayı\nGün sonu: Z raporu karşılaştırması, akaryakıt mutabakatı, market kapanışı ve günün kilitlenmesi\nİş günü gece yarısına göre değil, vardiya kapanışına göre belirlenir",
      steps:
        "Vardiya panosu'nda açık vardiyaları görün.\nVardiyalar'da kapanmış bir vardiyanın hesabını ve tutanağını açın.\nGün sonu'nda kilitlenmiş bir günün özetini ve kesilen fişi inceleyin.",
    },
    pos: {
      title: "Yerel kasa ve kampanyalar",
      menu: "Cihazlar ve ajanlar › Kasa satışları",
      summary:
        "İstasyondaki kasa internet kesilse de çalışır; satışlar bağlantı gelince buluta aktarılır. Fiyat ve kampanya merkezden yönetilir.",
      features:
        "Akaryakıt ve market satışı tek fişte; nakit, kart, veresiye ve karma ödeme\nKampanya motoru: ürün, sepet, saat dilimi ve müşteri seviyesine göre indirim\nYazar kasa (ÖKC) fişi ve Z raporu entegrasyonu (demoda simülatör)\nİptal, iade ve ödeme türü düzeltmesi denetim iziyle\nYaş sınırlı ürünlerde kasiyer onayı",
      steps:
        "Kasa satışları'nda bir fişi açın; satırları, ödemeleri ve uygulanan kampanyayı görün.\nKampanyalar'da saat dilimli bir kampanyanın koşullarını inceleyin.",
    },
    market: {
      title: "Market: stok, satın alma, sayım",
      menu: "Market › Market stoğu",
      summary:
        "Market ürünlerinin stoğu, son kullanma tarihleri, tedarikçi siparişleri, mal kabul, sayım ve raf etiketleri.",
      features:
        "Depo bazında stok, hareketler ve SKT / parti takibi\nSipariş önerisi, tedarikçi siparişi, mal kabul ve alış faturası eşleştirme\nTransfer, fire / imha ve sayım (fark onaya düşer)\nMaliyet ve kâr marjına göre fiyat önerisi, raf etiketi baskısı\nAlkol ve tütün satış belgelerinin süre takibi",
      steps:
        "Market stoğu'nda kritik seviyedeki ürünleri süzün.\nSKT ve partiler'de tarihi yaklaşan ürünleri görün.\nMarket raporları'nda kategori bazında satış ve kârlılığa bakın.",
    },
    wash: {
      title: "Araç yıkama",
      menu: "Yıkama › Üniteler",
      summary:
        "Otomatik yıkama üniteleri ve el yıkama: program, kredi, randevu, kimyasal tüketimi ve kârlılık.",
      features:
        "Ünitelerin canlı durumu, arıza ve duruş süreleri\nProgramlar ve reçeteler: kimyasal, su ve elektrik tüketimi\nYıkama kredisi ve abonelik; kasadan, uygulamadan ya da kodla başlatma\nEl yıkama için randevu, iş emri ve müşteri sıra ekranı\nYıkama başına maliyet ve marj raporu",
      steps:
        "Üniteler'de canlı durumu görün.\nÇalışmalar'da bugünün yıkamalarını tetikleme türüne göre süzün.\nYıkama raporları'nda ciro, kimyasal maliyeti ve marjı inceleyin.",
    },
    ev: {
      title: "Elektrikli araç şarjı",
      menu: "Şarj › Şarj panosu",
      summary:
        "Şarj üniteleri OCPP ile doğrudan platforma bağlanır: canlı durum, uzaktan başlatma, tarife, yük yönetimi ve faturalama.",
      features:
        "Konnektörlerin canlı durumu, süren oturumlarda enerji, güç ve süre\nSaat dilimli tarife, bekleme ücreti ve abonelik karşılaması\nUzaktan başlatma / durdurma; kartla, uygulamayla ya da kasadan ödeme\nYük yönetimi: istasyonun güç sınırı aşılmaz\nŞarj ağı ortaklarından oturum aktarımı ve düzenleyici raporlar",
      steps:
        "Şarj panosu'nda bir konnektörü uzaktan başlatın.\nŞarj oturumları'nda tamamlanan bir oturumun tutarını ve faturasını görün.\nŞarj raporları'nda enerji kaybı ve birim maliyete bakın.",
    },
    agents: {
      title: "İstasyon ajanları ve cihazlar",
      menu: "Cihazlar ve ajanlar › Ajanlar",
      summary:
        "Her istasyonda çalışan küçük bir yazılım (ajan) cihazlarla konuşur, veriyi yerelde tutar ve buluta aktarır. İnternet kesilse de istasyon çalışmayı sürdürür.",
      features:
        "Ajanların çevrimiçi durumu, sürümü, kuyruk derinliği ve saat sapması\nPompa, tank probu, yazar kasa, yıkama ve taşıt tanıma adaptörlerinin sağlığı\nUzaktan komut: yapılandırma güncelleme, günlük isteme, adaptörü yeniden başlatma\nTek kullanımlık kayıt koduyla güvenli kurulum\nAjan çevrimdışı kalınca alarm",
      steps:
        "Ajanlar'da istasyon özet kartlarını ve bağlantı durumunu görün.\nBir ajanı açıp adaptör sağlığını ve son komutları inceleyin.",
    },
    maintenance: {
      title: "Bakım ve mevzuat uyumu",
      menu: "Bakım ve uyum › Bakım iş emirleri",
      summary:
        "Pompa, tank, jeneratör gibi varlıkların bakımı ile lisans, kalibrasyon ve denetim belgelerinin süre takibi.",
      features:
        "Varlık kartları, periyodik bakım planları ve iş emirleri\nArıza alarmından tek tıkla iş emri; yanıt ve çözüm süresi (SLA) takibi\nUyum takvimi: lisans, ölçü ayarı, sızdırmazlık ve benzeri belgelerin bitiş tarihleri\nDenetim kayıtları ve düzeltici faaliyetler\nBakım maliyeti gider modülüne aktarılır",
      steps:
        "Bakım iş emirleri'nde süresi aşılmış bir iş emrini açın.\nUyum takvimi'nde yaklaşan belge yenilemelerini görün.",
    },
    counterparties: {
      title: "Cari hesaplar ve risk",
      menu: "Cari hesaplar › Cariler",
      summary:
        "Müşteri, tedarikçi ve personel hesapları: açık kalemler, vade, ekstre, yaşlandırma ve kredi limiti.",
      features:
        "Cari kartı: VKN / TCKN doğrulaması, adres, banka, e-fatura mükellefiyeti\nAçık kalem takibi ve vade; tahsilat ve ödemelerin kapatılması\nEkstre, yaşlandırma ve mutabakat mektubu (PDF)\nKredi ve çek risk limiti; limit aşımında uyar ya da engelle\nRisk panosu: limitine yaklaşan ve vadesi geçen cariler",
      steps:
        "Cariler'de bir müşterinin kartını ve ekstresini açın.\nRisk panosu'nda limitine yaklaşan carileri görün.\nCari raporları'nda yaşlandırma raporunu çalıştırın.",
    },
    treasury: {
      title: "Kasa, banka ve POS",
      menu: "Finans › Nakit pozisyonu",
      summary:
        "Nakit pozisyonu, kasalar, banka hesapları, kart POS yatışları, teminat mektupları, DBS ve krediler.",
      features:
        "Şirket ve istasyon bazında anlık nakit pozisyonu\nKasa ve banka hareketleri, virman ve banka ekstresi eşleştirme\nKart POS'u: gün sonu tutarı, komisyon ve valör tarihinde yatış takibi\nTeminat mektubu ve DBS (doğrudan borçlandırma) limitleri\nKredi ve taksit planları",
      steps:
        "Nakit pozisyonu'nda şirketin toplam nakdini görün.\nPOS ekranında yatışı beklenen gün sonu kayıtlarını inceleyin.",
    },
    instruments: {
      title: "Çek ve senet",
      menu: "Çek ve senet › Çek / senet portföyü",
      summary:
        "Alınan ve verilen çek / senetlerin bordroyla takibi: portföy, tahsil, ciro, karşılıksız ve vade takvimi.",
      features:
        "Giriş ve çıkış bordroları; her adım muhasebe fişi keser\nDurum makinesi: portföyde, tahsile verildi, ciro edildi, ödendi, karşılıksız\nVade takvimi ve hatırlatmalar\nKeşideci bazında risk ve yoğunlaşma raporu\nÇek karnesi ve yaprak takibi",
      steps:
        "Portföy'de vadesi yaklaşan çekleri görün.\nVade takvimi'nde haftalık tahsilat ve ödemeleri inceleyin.",
    },
    invoicing: {
      title: "Fatura ve e-belge",
      menu: "Fatura ve e-belge › Faturalar",
      summary:
        "Satış ve alış faturaları, e-Fatura, e-Arşiv ve e-İrsaliye. Gelen e-faturalar önerilerle deftere alınır.",
      features:
        "Satış faturası: tevkifat, istisna ve iskonto hesabı; e-Fatura / e-Arşiv gönderimi\nGelen kutusu: tedarikçi eşleştirme, satır önerisi ve tek tıkla deftere alma\nSistem seçimlerinizi öğrenir; aynı tedarikçinin sonraki faturasında önerir\ne-İrsaliye ve irsaliye–fatura bağlantısı\nKasadan istenen e-Arşiv faturaları",
      steps:
        "Faturalar'da bir satış faturasının belge görüntüsünü ve gönderim durumunu açın.\nGelen kutusu'nda bekleyen bir e-faturayı deftere alın.",
    },
    expenses: {
      title: "Giderler ve onay akışı",
      menu: "Gider ve bütçe › Giderler",
      summary: "Giderler kategori ve istasyon bazında kaydedilir; tutara ve türe göre onay akışından geçer.",
      features:
        "Gider kategorileri ve istasyonlar arası pay dağıtımı\nOnay politikaları: tutar eşiği, kategori ve kapsamına göre çok adımlı onay\nTekrarlayan giderler (kira, abonelik) kendiliğinden oluşur\nBelge eki ve denetim izi\nOnaylanan gider muhasebeleşir ve ödeme planına düşer",
      steps:
        "Giderler'de onay bekleyen bir gideri açın.\nOnaylar ekranından gideri onaylayın ya da gerekçeyle reddedin.",
    },
    payments: {
      title: "Ödeme planlama",
      menu: "Gider ve bütçe › Ödeme planlama",
      summary:
        "Vadesi gelen tedarikçi borçları ve giderler ödeme partilerinde toplanır, onaylanır ve bankaya verilir.",
      features:
        "Vadesi gelen ödemeler tek listede: giderler, tedarikçi borçları, vergiler\nÖdeme partisi: onay akışı ve banka toplu ödeme dosyası\nKısmi ödeme ve başarısız satırların yeni partiye alınması\nÖdeme sonrası açık kalemler kendiliğinden kapanır",
      steps: "Ödeme planlama'da bir partiyi açıp satırlarını ve onay durumunu inceleyin.",
    },
    cashflow: {
      title: "Nakit akış ve bütçe",
      menu: "Gider ve bütçe › Nakit akış",
      summary:
        "Önümüzdeki haftaların nakit girişi ve çıkışı öngörülür; bütçe ile gerçekleşen karşılaştırılır.",
      features:
        "Açık kalemler, çekler, POS yatışları, krediler ve vergilerden nakit projeksiyonu\nNakit açığı öngörülünce alarm\nYıllık bütçe: hesap, istasyon ve ay bazında\nBütçe–gerçekleşen sapma raporu",
      steps:
        "Nakit akış'ta haftalık projeksiyonu ve en düşük bakiye noktasını görün.\nBütçe'de sapması yüksek kalemleri inceleyin.",
    },
    accounting: {
      title: "Muhasebe",
      menu: "Muhasebe › Fişler",
      summary:
        "Tekdüzen Hesap Planı'na göre çift taraflı muhasebe. Satış, fatura, tahsilat ve gün sonu kayıtları fişlerini kendiliğinden keser.",
      features:
        "Yevmiye fişleri: boşluksuz numara, borç = alacak denetimi, ters kayıtla düzeltme\nMizan, muavin, kebir ve yevmiye raporları; Excel ve PDF\nHesap eşleştirmeleri şirket bazında değiştirilebilir; eksik eşleştirme bekleme kuyruğuna düşer\nDönem kapatma: kapalı döneme kayıt atılamaz\nİstasyon ve iş birimi analitik boyut olarak taşınır",
      steps:
        "Fişler'de gün sonundan gelen bir fişi açın.\nRaporlar'da mizanı istasyon kırılımıyla çalıştırın.\nEşleştirmeler'de bir satış türünün hangi hesaba gittiğini görün.",
    },
    taxCalendar: {
      title: "Vergi takvimi",
      menu: "Gider ve bütçe › Vergi takvimi",
      summary:
        "Beyanname ve ödeme tarihleri şirket bazında takip edilir; yaklaşan yükümlülükler hatırlatılır.",
      features:
        "KDV, muhtasar, geçici vergi ve benzeri yükümlülüklerin takvimi\nTahmini tutar ve nakit akışa yansıma\nSon güne yaklaşınca bildirim\nOranlar ve günler koda gömülü değildir; geçerlilik tarihiyle güncellenir",
      steps: "Vergi takvimi'nde bu ayın yükümlülüklerini ve durumlarını görün.",
    },
    customers: {
      title: "Müşteriler ve KVKK",
      menu: "Müşteriler › Müşteriler",
      summary:
        "Bireysel ve kurumsal müşterilerin tek görünümü: araçlar, harcama, puan ve izinler. KVKK yükümlülükleri sistemin içindedir.",
      features:
        "Müşteri kartı: araçlar, satış geçmişi, sadakat ve filo bağı\nAydınlatma metni ve açık rıza kayıtları sürümlü tutulur\nTicari ileti izinleri (İYS) ve pazarlama gönderimi\nİlgili kişi başvuruları ve yasal süre takibi\nKişisel veriler günlüklere ve bildirimlere yazılmaz",
      steps:
        "Müşteriler'de bir müşterinin 360° görünümünü açın.\nKVKK › KVKK başvuruları'nda süresi yaklaşan bir başvuruyu inceleyin.",
    },
    fleet: {
      title: "Filo ve taşıt tanıma",
      menu: "Filo › Filo hesapları",
      summary:
        "Kurumsal filo müşterileri: araç bazında limit ve kural, taşıt tanıma ile satış, dönemsel faturalama.",
      features:
        "Araç, sürücü ve kart tanımları\nKurallar: günlük / aylık limit, ürün ve istasyon kısıtı, saat aralığı\nTaşıt tanıma (TTS) okumasıyla satışın araca bağlanması\nKural ihlalinde kasada uyarı ya da engel\nDönem sonunda toplu fatura ve tüketim raporu",
      steps:
        "Filo hesapları'nda bir filonun araçlarını ve limitlerini görün.\nTüketim raporu'nda araç bazında litre ve tutarı inceleyin.",
    },
    loyalty: {
      title: "Sadakat, kupon ve abonelik",
      menu: "Sadakat › Program ve marka",
      summary:
        "Puan kazanımı ve harcaması, müşteri seviyeleri, kupon kampanyaları ve yıkama / şarj abonelikleri.",
      features:
        "Kazanım kuralları: ürün, tutar ve kampanya dönemine göre\nSeviyeler ve seviyeye özel avantajlar\nKupon üretimi, dağıtımı ve kullanım takibi\nŞüpheli puan hareketleri inceleme kuyruğuna düşer\nPuan yükümlülüğü muhasebede izlenir",
      steps:
        "Kuponlar'da etkin bir kampanyanın kullanım oranını görün.\nSadakat raporları'nda puan yükümlülüğünü inceleyin.",
    },
    portal: {
      title: "Filo müşteri portalı",
      menu: "Müşteri portalı",
      summary:
        "Filo müşteriniz kendi hesabına girer: araçlarını, tüketimini ve faturalarını görür, yeni araç talebi açar.",
      features:
        "Yalnızca kendi carisinin verisi görünür\nAraç listesi, limitler ve işlem geçmişi\nFatura ve ekstre indirme\nYeni araç ya da limit değişikliği talebi",
      steps: "Portalda araçlar ve işlemler sekmelerini gezin; bir araç talebi açın.",
    },
    home: {
      title: "Ana sayfa ve panolar",
      menu: "Genel › Ana sayfa",
      summary:
        "Her kullanıcı ana sayfada kendi işini görür: rolüne göre hızlı işlemler ve satır başına tek eylemli bekleyen işler. Yöneticiler ayrıca günün özetini ve eğilimi görür.",
      features:
        "“Ne yapmak istiyorsunuz?” düğmeleri formu doğrudan açar\n“Bekleyen işler”: alarm, onay, kapanmamış gün, kritik tank; her satırda tek eylem\nMenüde yalnızca rolün işleri (“İşlerim”); diğer sayfalar “Tüm modüller” ve menü aramasında\nÜst çubuktaki “Yeni kayıt” ile her sayfadan veri girişi\nBugünün cirosu ve hacmi canlı sayaçlarla; dün ve geçen haftayla karşılaştırma",
      steps:
        "Ana sayfadaki hızlı işlemlerden birine tıklayın; form doğrudan açılır.\nSol menünün arama kutusuna “mutabakat” yazıp sayfayı bulun.",
    },
    reports: {
      title: "Rapor merkezi",
      menu: "Raporlar › Rapor merkezi",
      summary:
        "İstasyon karşılaştırma, akaryakıt analitiği, kârlılık ve finans raporları. Raporlar zamanlanıp e-postayla gönderilebilir.",
      features:
        "İstasyonları ciro, hacim, marj ve fireye göre karşılaştırma\nAkaryakıt analitiği: saatlik yoğunluk, ürün karması, tabanca verimi\nKârlılık ve tutarlılık: satış, stok ve muhasebe arasındaki farklar\nKayıtlı filtreler, favoriler ve Excel / PDF dışa aktarım\nZamanlanmış raporlar: günlük, haftalık, aylık e-posta",
      steps:
        "İstasyon karşılaştırma'da dönemi değiştirip sıralamayı izleyin.\nZamanlanmış raporlar'da sabah özetinin alıcılarını görün.",
    },
    alarms: {
      title: "Alarm ve bildirimler",
      menu: "Alarmlar › Alarmlar",
      summary:
        "Kritik tank seviyesi, kasa açığı, çevrimdışı ajan, vadesi geçen çek gibi durumlar doğru kişiye doğru kanaldan ulaşır.",
      features:
        "Hazır kural kataloğu; eşikler işletme ve istasyon bazında değiştirilebilir\nAlarm tekilleşir, kendiliğinden çözülür, süresinde ilgilenilmezse yükseltilir\nGörüldü, atandı, çözüldü akışı ve notlar\nKişisel bildirim tercihleri: uygulama içi, e-posta, SMS, mobil bildirim; sessiz saatler\nGünlük özet e-postası",
      steps:
        "Alarmlar'da kritik bir alarmı açıp birine atayın.\nAlarm kuralları'nda bir kuralın eşiğini inceleyin.",
    },
    approvals: {
      title: "Onaylar",
      menu: "Genel › Onaylar",
      summary:
        "Gider, ödeme, fiyat değişikliği, stok farkı gibi işlemler tek onay kutusunda toplanır. Kimse kendi talebini onaylayamaz.",
      features:
        "Çok adımlı onay politikaları\nTalebin kaynağı belgeye tek tıkla erişim\nSüresi dolan talepler yükseltilir\nHer karar denetim izine yazılır",
      steps: "Onaylar'da bekleyen bir talebi açıp kararınızı verin.",
    },
    pricing: {
      title: "Ürün kataloğu ve fiyatlar",
      menu: "Ürün ve fiyat › Fiyatlar",
      summary:
        "Akaryakıt, market ve hizmet fiyatları merkezden yönetilir; değişiklikler ileri tarihli planlanır ve pompaya kendiliğinden iner.",
      features:
        "İstasyon ve fiyat grubu bazında fiyat\nİleri tarihli fiyat değişikliği ve onay akışı\nFiyat değişikliği ajan üzerinden pompaya ve kasaya iletilir\nFiyat geçmişi ve fiyat farkı raporu",
      steps:
        "Fiyatlar'da bir ürünün istasyonlara göre fiyatını görün.\nPlanlı bir fiyat değişikliğini ve onay durumunu açın.",
    },
    organization: {
      title: "Kuruluş, kullanıcı ve roller",
      menu: "Ayarlar › Kullanıcılar",
      summary:
        "Şirketler, bölgeler, istasyonlar ve iş birimleri; kullanıcılar, roller ve kapsamlı yetkilendirme.",
      features:
        "Kullanıcı daveti; hazır roller ve özel rol tanımı\nKapsam: işletme, şirket, bölge ya da istasyon düzeyinde yetki\nİki adımlı doğrulama ve oturum yönetimi\nModüller işletme ve istasyon bazında açılıp kapatılır\nİstasyonun başka bir işletmeye devri",
      steps:
        "Kullanıcılar'da bir kullanıcının rol ve kapsamını açın.\nRoller'de özel bir rolün izinlerini inceleyin.",
    },
    platform: {
      title: "Platform yönetimi",
      menu: "Platform paneli",
      summary:
        "Yazılımı sunan ekibin paneli: işletmeler, planlar, abonelik faturaları, tahsilat, duyurular ve sistem sağlığı.",
      features:
        "İşletme listesi, kullanım ölçümü ve plan değişikliği\nAbonelik faturalama, tahsilat ve gecikme süreci\nDestek erişimi: işletmenin onayıyla, süreli ve salt okunur\nDuyurular ve istasyon ajanı yayınları\nSistem sağlığı ve kuyruk durumu",
      steps:
        "Platform panelinde işletmeleri ve abonelik durumlarını görün.\nTahsilat ekranında gecikmiş faturaları inceleyin.",
    },
    subscription: {
      title: "Abonelik ve destek erişimi",
      menu: "Ayarlar › Abonelik ve faturalar",
      summary:
        "İşletme kendi planını, kullanımını ve platform faturalarını görür; destek ekibinin erişim isteğini onaylar ya da reddeder.",
      features:
        "Plan, dönem ve plandaki modüller\nKullanım: istasyon, kullanıcı ve işlem sayıları\nPlatform faturaları ve ödeme durumu\nVerinin tamamının dışa aktarımı\nDestek erişimi istekleri ve geçmişi",
      steps:
        "Abonelik ve faturalar'da planı ve açık faturayı görün.\nDestek erişimi'nde bekleyen isteği onaylayın.",
    },
  },
  notes: {
    title: "Demo hakkında",
    items:
      "Veriler örnektir; gerçek bir işletmeye ait değildir.\nCihazlar simülatördür: pompa, tank probu, yazar kasa ve şarj üniteleri gerçek cihaz gibi veri üretir.\nE-posta ve SMS gönderilmez; e-belgeler örnek sağlayıcıya gider.\nVergi oranları ve mevzuat süreleri örnek değerlerdir.\nDemo verisi zaman zaman sıfırlanır; girdiğiniz kayıtlar kalıcı değildir.",
  },
  switchRole: "Rol değiştir",
  classic: {
    title: "E-posta ve parolayla giriş",
    back: "Rol kartlarına dön",
  },
};
